import React from 'react'
import PropTypes from 'prop-types'
import CustomHero from './CustomHero'

function CustomHeroCarousel({ data, slug }) {
  const heros = data
  const slotCount = heros.length
  let slotIndex = 0

  const doNav = delta => {
    slotIndex += delta
    if (slotIndex <= 0) slotIndex += slotCount
    slotIndex %= slotCount
    const content = document.querySelector('div.hero-carousel > div.content')
    if (!content) return

    Array.from(content.classList).forEach(cl => {
      if (cl.indexOf('slot-') === 0) content.classList.remove(cl)
    })

    content.classList.add(`slot-${slotIndex}`)
  }

  /* eslint-disable react/no-array-index-key */
  return (
    <div className="hero-carousel">
      <div className="nav">
        <input
          type="image"
          className="prev"
          alt="Prev"
          src={require('../../assets/images/icons/nav-arrow.svg')}
          onClick={() => doNav(-1)}
        />
        <input
          type="image"
          className="next"
          alt="Next"
          src={require('../../assets/images/icons/nav-arrow.svg')}
          onClick={() => doNav(1)}
        />
      </div>
      <div className={`content slot-${slotIndex}`}>
        {heros.map((hero, index) => (
          <CustomHero data={hero} slug={slug} key={index} carouselIndex={index} />
        ))}
      </div>
    </div>
  )
}

CustomHeroCarousel.defaultProps = {
  slug: null
}

CustomHeroCarousel.propTypes = {
  data: PropTypes.object.isRequired,
  slug: PropTypes.string
}

export default CustomHeroCarousel
